import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useState } from "react";
import { Button, styled } from "@mui/material";

// components
import { AccessTab } from "./tab-access";
import { RegulationsTab } from "./tab-regulations";
import { LocationTab } from "./tab-location";
import { BoundariesTab } from "./tab-boundaries";

// svg
import { ReactComponent as IconLocation } from "../../../assets/svg/location.svg";
import { ReactComponent as IconArea } from "../../../assets/svg/area.svg";
import { ReactComponent as IconRegulations } from "../../../assets/svg/regulations.svg";
import { ReactComponent as IconTruck } from "../../../assets/svg/truck.svg";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export const VerticalTabs = ({
  tabValue,
  handleChange,
  updatePropertyData,
  propertyData,
  steps,
  regulationsError,
  setRegulationsError,
  maxInnerBuildHeight,
  isValidPolygon,
  setUploading,
  uploading,
  deleteDrawing
}) => {
  return (
    <>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={tabValue}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{
          borderRight: 1,
          borderColor: "#E7E7F2",
          background: "transparent",
          width: "60px",
          minWidth: "60px",
          maxWidth: "60px",
          padding: 0,
        }}
        textColor="secondary"
        indicatorColor="secondary"
        scrollButtons={false}
      >
        <Tab
          icon={
            <IconLocation
              fill={
                steps.location
                  ? "#0FC23C"
                  : tabValue === 0
                  ? "#343745"
                  : "#A2A3A9"
              }
            />
          }
          {...a11yProps(0)}
          sx={{ minWidth: "40px" }}
        />
        <Tab
          icon={
            <IconArea
              fill={
                steps.boundaries
                  ? "#0FC23C"
                  : tabValue === 1
                  ? "#343745"
                  : "#A2A3A9"
              }
            />
          }
          {...a11yProps(1)}
          sx={{ minWidth: "40px" }}
          disabled={!steps.location}
        />
        <Tab
          icon={
            <IconTruck
              fill={
                steps.access
                  ? "#0FC23C"
                  : tabValue === 2
                  ? "#343745"
                  : "#A2A3A9"
              }
            />
          }
          {...a11yProps(2)}
          sx={{ minWidth: "40px" }}
          disabled={!steps.boundaries || !isValidPolygon}
        />
        <Tab
          icon={
            <IconRegulations
              fill={
                steps.regulations
                  ? "#0FC23C"
                  : tabValue === 3
                  ? "#343745"
                  : '#c7c7d6'/* "#A2A3A9" */
              }
            />
          }
          {...a11yProps(3)}
          sx={{ minWidth: "40px" }}
          disabled={!steps.access || !isValidPolygon}
        />
      </Tabs>
      {tabValue === 0 ? (
        <LocationTab location={propertyData.locationGeodata} />
      ) : tabValue === 1 ? (
        <BoundariesTab
          propertyData={propertyData}
          propertyArea={propertyData.propertyArea}
          perimeter={propertyData.perimeter}
          propertyGeoJSON={propertyData.propertyGeoJSON}
          updatePropertyData={updatePropertyData}
          setUploading={setUploading}
          uploading={uploading}
          deleteDrawing={deleteDrawing}
        />
      ) : tabValue === 2 ? (
        <AccessTab selectedLine={propertyData.selectedLine} />
      ) : (
        <RegulationsTab
          propertyData={propertyData}
          updatePropertyData={updatePropertyData}
          setRegulationsError={setRegulationsError}
          maxInnerBuildHeight={maxInnerBuildHeight}
        />
      )}
    </>
  );
};
